
import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { notification } from 'antd';
import { hideNotification } from '../redux/actions/notification';

function GlobalNotification() {
  const dispatch = useDispatch();
  const { type, message, description } = useSelector((state) => state.notification || {});

  useEffect(() => {
    if (message) {
      notification[type || 'info']({
        message,
        description,
      });

      const timer = setTimeout(() => {
        dispatch(hideNotification());
      }, 3000);
  
      return () => clearTimeout(timer);
    }
  }, [message, type, description, dispatch]);

  return null;
}

export default GlobalNotification;
